define('businessServices/onboarding/liveReceptionistOnboardingSingleton',[
    'common/promises/promiseFactory',
    'constants/dayOfWeekEnumeration',
    'constants/liveReceptionistOnboardingStatusConstants',
    'persistence/repositories/liveReceptionistOnboardingRepository'
], function() {
    const LiveReceptionistOnboardingSingleton = function() {

        const PromiseFactory = require('common/promises/promiseFactory');
        const _promiseFactory = new PromiseFactory();

        const _dayOfWeekEnumeration = require('constants/dayOfWeekEnumeration');
        const _liveReceptionistOnboardingStatus = require('constants/liveReceptionistOnboardingStatusConstants');

        let _disposables = [];

        const LiveReceptionistOnboardingRepository = require('persistence/repositories/liveReceptionistOnboardingRepository');
        const _liveReceptionistOnboardingRepository = new LiveReceptionistOnboardingRepository();

        this.isLoaded = false;

        // private state observables
        this.state = {
            liveReceptionistOnboardingId: ko.observable(null),
            numberIntentSelection: ko.observable(null),
            mayForwardFromNumbers: ko.observableArray([]),
            accountBusinessName: ko.observable(null),
            businessName: ko.observable(null),
            businessDescription: ko.observable(null),
            agentTone: ko.observable(null),
            industry: ko.observable(null),
            numberOfEmployees: ko.observable(null),
            timeZone: ko.observable(null),
            mondayOpenTime: ko.observable(null),
            mondayCloseTime: ko.observable(null),
            tuesdayOpenTime: ko.observable(null),
            tuesdayCloseTime: ko.observable(null),
            wednesdayOpenTime: ko.observable(null),
            wednesdayCloseTime: ko.observable(null),
            thursdayOpenTime: ko.observable(null),
            thursdayCloseTime: ko.observable(null),
            fridayOpenTime: ko.observable(null),
            fridayCloseTime: ko.observable(null),
            saturdayOpenTime: ko.observable(null),
            saturdayCloseTime: ko.observable(null),
            sundayOpenTime: ko.observable(null),
            sundayCloseTime: ko.observable(null),
            callerFollowUp: ko.observable(null),
            callerFollowUpOther: ko.observable(null),
            addressLineOne: ko.observable(null),
            addressLineTwo: ko.observable(null),
            city: ko.observable(null),
            region: ko.observable(null),
            postalCode: ko.observable(null),
            country: ko.observable(null),
            phoneNumber: ko.observable(null),
            faxNumber: ko.observable(null),
            emailAddress: ko.observable(null),
            websiteUrl: ko.observable(null),
            teamMembers: ko.observableArray([]),
            messageRecipients: ko.observableArray([]),
            smsRecipients: ko.observableArray([]),
            onboardingStatus: ko.observable(_liveReceptionistOnboardingStatus.initiated),
        };

        // use pureComputed so these values cannot be accidentally overwritten without calling the setters
        this.liveReceptionistOnboardingId = ko.pureComputed(() => this.state.liveReceptionistOnboardingId());

        this.numberIntentSelection = ko.pureComputed(() => this.state.numberIntentSelection());
        this.mayForwardFromNumbers = ko.pureComputed(() => this.state.mayForwardFromNumbers());
        this.accountBusinessName = ko.pureComputed(() => this.state.accountBusinessName());
        this.businessName = ko.pureComputed(() => this.state.businessName());
        this.businessDescription = ko.pureComputed(() => this.state.businessDescription());
        this.industry = ko.pureComputed(() => this.state.industry());
        this.numberOfEmployees = ko.pureComputed(() => this.state.numberOfEmployees());
        this.agentTone = ko.pureComputed(() => this.state.agentTone());

        this.timeZone = ko.pureComputed(() => this.state.timeZone());
        this.mondayOpenTime = ko.pureComputed(() => this.state.mondayOpenTime());
        this.mondayCloseTime = ko.pureComputed(() => this.state.mondayCloseTime());
        this.tuesdayOpenTime = ko.pureComputed(() => this.state.tuesdayOpenTime());
        this.tuesdayCloseTime = ko.pureComputed(() => this.state.tuesdayCloseTime());
        this.wednesdayOpenTime = ko.pureComputed(() => this.state.wednesdayOpenTime());
        this.wednesdayCloseTime = ko.pureComputed(() => this.state.wednesdayCloseTime());
        this.thursdayOpenTime = ko.pureComputed(() => this.state.thursdayOpenTime());
        this.thursdayCloseTime = ko.pureComputed(() => this.state.thursdayCloseTime());
        this.fridayOpenTime = ko.pureComputed(() => this.state.fridayOpenTime());
        this.fridayCloseTime = ko.pureComputed(() => this.state.fridayCloseTime());
        this.saturdayOpenTime = ko.pureComputed(() => this.state.saturdayOpenTime());
        this.saturdayCloseTime = ko.pureComputed(() => this.state.saturdayCloseTime());
        this.sundayOpenTime = ko.pureComputed(() => this.state.sundayOpenTime());
        this.sundayCloseTime = ko.pureComputed(() => this.state.sundayCloseTime());
        this.callerFollowUp = ko.pureComputed(() => this.state.callerFollowUp());
        this.callerFollowUpOther = ko.pureComputed(() => this.state.callerFollowUpOther());

        this.addressLineOne = ko.pureComputed(() => this.state.addressLineOne());
        this.addressLineTwo = ko.pureComputed(() => this.state.addressLineTwo());
        this.city = ko.pureComputed(() => this.state.city());
        this.region = ko.pureComputed(() => this.state.region());
        this.postalCode = ko.pureComputed(() => this.state.postalCode());
        this.country = ko.pureComputed(() => this.state.country());
        this.phoneNumber = ko.pureComputed(() => this.state.phoneNumber());
        this.faxNumber = ko.pureComputed(() => this.state.faxNumber());
        this.emailAddress = ko.pureComputed(() => this.state.emailAddress());
        this.websiteUrl = ko.pureComputed(() => this.state.websiteUrl());
        this.teamMembers = ko.pureComputed(() => this.state.teamMembers());

        this.messageRecipients = ko.pureComputed(() => this.state.messageRecipients());
        this.smsRecipients = ko.pureComputed(() => this.state.smsRecipients());

        this.onboardingStatus = ko.pureComputed(() => this.state.onboardingStatus());

        this.progressPercentage = ko.observable(0);

        this.alerts = {
            receiveAlertLoginSuccessful: () => this.clear(),
            receiveAlertLogout: () => this.clear()
        };

        const _buildOnboardingStateData = () => {
            return {
                liveReceptionistOnboardingId: this.liveReceptionistOnboardingId(),
                numberIntentSelection: this.numberIntentSelection(),
                mayForwardFromNumbers: this.mayForwardFromNumbers(),
                accountBusinessName: this.accountBusinessName(),
                businessName: this.businessName(),
                businessDescription: this.businessDescription(),
                agentTone: this.agentTone(),
                industry: this.industry(),
                numberOfEmployees: this.numberOfEmployees(),
                timeZone: this.timeZone(),
                mondayOpenTime: this.mondayOpenTime(),
                mondayCloseTime: this.mondayCloseTime(),
                tuesdayOpenTime: this.tuesdayOpenTime(),
                tuesdayCloseTime: this.tuesdayCloseTime(),
                wednesdayOpenTime: this.wednesdayOpenTime(),
                wednesdayCloseTime: this.wednesdayCloseTime(),
                thursdayOpenTime: this.thursdayOpenTime(),
                thursdayCloseTime: this.thursdayCloseTime(),
                fridayOpenTime: this.fridayOpenTime(),
                fridayCloseTime: this.fridayCloseTime(),
                saturdayOpenTime: this.saturdayOpenTime(),
                saturdayCloseTime: this.saturdayCloseTime(),
                sundayOpenTime: this.sundayOpenTime(),
                sundayCloseTime: this.sundayCloseTime(),
                callerFollowUp: this.callerFollowUp(),
                callerFollowUpOther: this.callerFollowUpOther(),
                addressLineOne: this.addressLineOne(),
                addressLineTwo: this.addressLineTwo(),
                city: this.city(),
                region: this.region(),
                postalCode: this.postalCode(),
                country: this.country(),
                phoneNumber: this.phoneNumber(),
                faxNumber: this.faxNumber(),
                emailAddress: this.emailAddress(),
                websiteUrl: this.websiteUrl(),
                teamMembers: this.teamMembers(),
                messageRecipients: this.messageRecipients(),
                smsRecipients: this.smsRecipients(),
                onboardingStatus: this.onboardingStatus()
            };
        };

        this.initialize = () => {
            return _promiseFactory.deferIndefinitely((deferredObject) => {
                _liveReceptionistOnboardingRepository.getLiveReceptionistOnboarding()
                    .then((result) => {
                        if (result.isSuccessful) {
                            // Existing onboarding session found, set the state
                            const { liveReceptionistOnboarding } = result;
                            this.state.liveReceptionistOnboardingId(liveReceptionistOnboarding.liveReceptionistOnboardingId);
                            this.state.numberIntentSelection(liveReceptionistOnboarding.numberIntentSelection);
                            this.state.accountBusinessName(liveReceptionistOnboarding.accountBusinessName);
                            this.state.businessName(liveReceptionistOnboarding.businessName);
                            this.state.businessDescription(liveReceptionistOnboarding.businessDescription);
                            this.state.agentTone(liveReceptionistOnboarding.agentTone);
                            this.state.industry(liveReceptionistOnboarding.industry);
                            this.state.numberOfEmployees(liveReceptionistOnboarding.numberOfEmployees);
                            this.state.timeZone(liveReceptionistOnboarding.timeZone);
                            this.state.mondayOpenTime(liveReceptionistOnboarding.mondayOpenTime);
                            this.state.mondayCloseTime(liveReceptionistOnboarding.mondayCloseTime);
                            this.state.tuesdayOpenTime(liveReceptionistOnboarding.tuesdayOpenTime);
                            this.state.tuesdayCloseTime(liveReceptionistOnboarding.tuesdayCloseTime);
                            this.state.wednesdayOpenTime(liveReceptionistOnboarding.wednesdayOpenTime);
                            this.state.wednesdayCloseTime(liveReceptionistOnboarding.wednesdayCloseTime);
                            this.state.thursdayOpenTime(liveReceptionistOnboarding.thursdayOpenTime);
                            this.state.thursdayCloseTime(liveReceptionistOnboarding.thursdayCloseTime);
                            this.state.fridayOpenTime(liveReceptionistOnboarding.fridayOpenTime);
                            this.state.fridayCloseTime(liveReceptionistOnboarding.fridayCloseTime);
                            this.state.saturdayOpenTime(liveReceptionistOnboarding.saturdayOpenTime);
                            this.state.saturdayCloseTime(liveReceptionistOnboarding.saturdayCloseTime);
                            this.state.sundayOpenTime(liveReceptionistOnboarding.sundayOpenTime);
                            this.state.sundayCloseTime(liveReceptionistOnboarding.sundayCloseTime);
                            this.state.callerFollowUp(liveReceptionistOnboarding.callerFollowUp);
                            this.state.callerFollowUpOther(liveReceptionistOnboarding.callerFollowUpOther);
                            this.state.addressLineOne(liveReceptionistOnboarding.addressLineOne);
                            this.state.addressLineTwo(liveReceptionistOnboarding.addressLineTwo);
                            this.state.city(liveReceptionistOnboarding.city);
                            this.state.region(liveReceptionistOnboarding.regionCode);
                            this.state.postalCode(liveReceptionistOnboarding.postalCode);
                            this.state.country(liveReceptionistOnboarding.countryCode);
                            this.state.phoneNumber(liveReceptionistOnboarding.phoneNumber);
                            this.state.faxNumber(liveReceptionistOnboarding.faxNumber);
                            this.state.emailAddress(liveReceptionistOnboarding.emailAddress);
                            this.state.websiteUrl(liveReceptionistOnboarding.websiteUrl);

                            this.state.mayForwardFromNumbers.removeAll();
                            if (liveReceptionistOnboarding.mayForwardFromNumbers) {
                                liveReceptionistOnboarding.mayForwardFromNumbers.forEach(mayForwardFromNumber => {
                                    this.state.mayForwardFromNumbers.push(mayForwardFromNumber);
                                });
                            }

                            this.state.teamMembers.removeAll();
                            if (liveReceptionistOnboarding.teamMembers){
                                liveReceptionistOnboarding.teamMembers.forEach(teamMember => {
                                    this.state.teamMembers.push(teamMember);
                                });
                            }

                            this.state.messageRecipients.removeAll();
                            if (liveReceptionistOnboarding.messageRecipients){
                                liveReceptionistOnboarding.messageRecipients.forEach(messageRecipient => {
                                    this.state.messageRecipients.push(messageRecipient);
                                });
                            }

                            this.state.smsRecipients.removeAll();
                            if (liveReceptionistOnboarding.smsRecipients){
                                liveReceptionistOnboarding.smsRecipients.forEach(smsRecipient => {
                                    this.state.smsRecipients.push(smsRecipient);
                                });
                            }


                            this.state.onboardingStatus(liveReceptionistOnboarding.onboardingStatus);

                            this.isLoaded = true;
                            deferredObject.resolve();
                        } else {
                            // No existing onboarding session, create a new one
                            return _liveReceptionistOnboardingRepository.createLiveReceptionistOnboarding()
                                .then((newOnboarding) => {
                                    const { liveReceptionistOnboarding } = newOnboarding;
                                    this.state.liveReceptionistOnboardingId(liveReceptionistOnboarding.liveReceptionistOnboardingId);
                                    this.state.numberIntentSelection(liveReceptionistOnboarding.numberIntentSelection);
                                    this.state.accountBusinessName(liveReceptionistOnboarding.accountBusinessName);
                                    this.state.businessName(liveReceptionistOnboarding.businessName);
                                    this.state.businessDescription(liveReceptionistOnboarding.businessDescription);
                                    this.state.agentTone(liveReceptionistOnboarding.agentTone);
                                    this.state.industry(liveReceptionistOnboarding.industry);
                                    this.state.numberOfEmployees(liveReceptionistOnboarding.numberOfEmployees);
                                    this.state.timeZone(liveReceptionistOnboarding.timeZone);
                                    this.state.mondayOpenTime(liveReceptionistOnboarding.mondayOpenTime);
                                    this.state.mondayCloseTime(liveReceptionistOnboarding.mondayCloseTime);
                                    this.state.tuesdayOpenTime(liveReceptionistOnboarding.tuesdayOpenTime);
                                    this.state.tuesdayCloseTime(liveReceptionistOnboarding.tuesdayCloseTime);
                                    this.state.wednesdayOpenTime(liveReceptionistOnboarding.wednesdayOpenTime);
                                    this.state.wednesdayCloseTime(liveReceptionistOnboarding.wednesdayCloseTime);
                                    this.state.thursdayOpenTime(liveReceptionistOnboarding.thursdayOpenTime);
                                    this.state.thursdayCloseTime(liveReceptionistOnboarding.thursdayCloseTime);
                                    this.state.fridayOpenTime(liveReceptionistOnboarding.fridayOpenTime);
                                    this.state.fridayCloseTime(liveReceptionistOnboarding.fridayCloseTime);
                                    this.state.saturdayOpenTime(liveReceptionistOnboarding.saturdayOpenTime);
                                    this.state.saturdayCloseTime(liveReceptionistOnboarding.saturdayCloseTime);
                                    this.state.sundayOpenTime(liveReceptionistOnboarding.sundayOpenTime);
                                    this.state.sundayCloseTime(liveReceptionistOnboarding.sundayCloseTime);
                                    this.state.callerFollowUp(liveReceptionistOnboarding.callerFollowUp);
                                    this.state.callerFollowUpOther(liveReceptionistOnboarding.callerFollowUpOther);
                                    this.state.addressLineOne(liveReceptionistOnboarding.addressLineOne);
                                    this.state.addressLineTwo(liveReceptionistOnboarding.addressLineTwo);
                                    this.state.city(liveReceptionistOnboarding.city);
                                    this.state.region(liveReceptionistOnboarding.regionCode);
                                    this.state.postalCode(liveReceptionistOnboarding.postalCode);
                                    this.state.country(liveReceptionistOnboarding.countryCode);
                                    this.state.phoneNumber(liveReceptionistOnboarding.phoneNumber);
                                    this.state.faxNumber(liveReceptionistOnboarding.faxNumber);
                                    this.state.emailAddress(liveReceptionistOnboarding.emailAddress);
                                    this.state.websiteUrl(liveReceptionistOnboarding.websiteUrl);

                                    this.state.mayForwardFromNumbers.removeAll();
                                    if (liveReceptionistOnboarding.mayForwardFromNumbers) {
                                        liveReceptionistOnboarding.mayForwardFromNumbers.forEach(mayForwardFromNumber => {
                                            this.state.mayForwardFromNumbers.push(mayForwardFromNumber);
                                        });
                                    }

                                    this.state.teamMembers.removeAll();
                                    if (liveReceptionistOnboarding.teamMembers){
                                        liveReceptionistOnboarding.teamMembers.forEach(teamMember => {
                                            this.state.teamMembers.push(teamMember);
                                        });
                                    }

                                    this.state.messageRecipients.removeAll();
                                    if (liveReceptionistOnboarding.messageRecipients){
                                        liveReceptionistOnboarding.messageRecipients.forEach(messageRecipient => {
                                            this.state.messageRecipients.push(messageRecipient);
                                        });
                                    }

                                    this.state.smsRecipients.removeAll();
                                    if (liveReceptionistOnboarding.smsRecipients){
                                        liveReceptionistOnboarding.smsRecipients.forEach(smsRecipient => {
                                            this.state.smsRecipients.push(smsRecipient);
                                        });
                                    }


                                    this.state.onboardingStatus(liveReceptionistOnboarding.onboardingStatus);

                                    this.isLoaded = true;
                                    deferredObject.resolve();
                                });
                        }
                    })
                    .fail((error) => {
                        deferredObject.reject(error);
                    });
            });
        };

        this.clear = () => {
            this.state.liveReceptionistOnboardingId(null);
            this.state.numberIntentSelection(null);
            this.state.accountBusinessName(null);
            this.state.businessName(null);
            this.state.businessDescription(null);
            this.state.agentTone(null);
            this.state.industry(null);
            this.state.numberOfEmployees(null);
            this.state.timeZone(null);
            this.state.mondayOpenTime(null);
            this.state.mondayCloseTime(null);
            this.state.tuesdayOpenTime(null);
            this.state.tuesdayCloseTime(null);
            this.state.wednesdayOpenTime(null);
            this.state.wednesdayCloseTime(null);
            this.state.thursdayOpenTime(null);
            this.state.thursdayCloseTime(null);
            this.state.fridayOpenTime(null);
            this.state.fridayCloseTime(null);
            this.state.saturdayOpenTime(null);
            this.state.saturdayCloseTime(null);
            this.state.sundayOpenTime(null);
            this.state.sundayCloseTime(null);
            this.state.callerFollowUp(null);
            this.state.callerFollowUpOther(null);
            this.state.addressLineOne(null);
            this.state.addressLineTwo(null);
            this.state.city(null);
            this.state.region(null);
            this.state.postalCode(null);
            this.state.country(null);
            this.state.phoneNumber(null);
            this.state.faxNumber(null);
            this.state.emailAddress(null);
            this.state.websiteUrl(null);
            this.state.mayForwardFromNumbers.removeAll();
            this.state.teamMembers.removeAll();
            this.state.messageRecipients.removeAll();
            this.state.smsRecipients.removeAll();
            this.state.onboardingStatus(null);

            this.isLoaded = false;
        };

        this.getLiveReceptionistOnboarding = (forceLoad = false) => {
            return _promiseFactory.deferIndefinitely((deferredObject) => {
                if (this.isLoaded === false || forceLoad === true) {
                    return this.initialize()
                        .then(() => {
                            deferredObject.resolve(_buildOnboardingStateData());
                        });
                } else {
                    deferredObject.resolve(_buildOnboardingStateData());
                }
            });
        };

        this.saveAccountBusinessName = (accountBusinessName) => {
            return _promiseFactory.deferIndefinitely((deferredObject) => {
                _liveReceptionistOnboardingRepository.saveAccountBusinessName(this.liveReceptionistOnboardingId(), accountBusinessName)
                    .then((result) => {
                        this.state.accountBusinessName(accountBusinessName);
                        deferredObject.resolve(result);
                    });
            });
        };

        this.saveBusinessName = (businessName) => {
            return _promiseFactory.deferIndefinitely((deferredObject) => {
                _liveReceptionistOnboardingRepository.saveBusinessName(this.liveReceptionistOnboardingId(), businessName)
                    .then((result) => {
                        this.state.businessName(businessName);
                        deferredObject.resolve(result);
                    });
            });
        };

        this.saveAddressLineOne = (addressLineOne) => {
            return _promiseFactory.deferIndefinitely((deferredObject) => {
                _liveReceptionistOnboardingRepository.saveAddressLineOne(this.liveReceptionistOnboardingId(), addressLineOne)
                    .then((result) => {
                        this.state.addressLineOne(addressLineOne);
                        deferredObject.resolve(result);
                    });
            });
        };

        this.saveAddressLineTwo = (addressLineTwo) => {
            return _promiseFactory.deferIndefinitely((deferredObject) => {
                _liveReceptionistOnboardingRepository.saveAddressLineTwo(this.liveReceptionistOnboardingId(), addressLineTwo)
                    .then((result) => {
                        this.state.addressLineTwo(addressLineTwo);
                        deferredObject.resolve(result);
                    });
            });
        };

        this.saveCity = (city) => {
            return _promiseFactory.deferIndefinitely((deferredObject) => {
                _liveReceptionistOnboardingRepository.saveCity(this.liveReceptionistOnboardingId(), city)
                    .then((result) => {
                        this.state.city(city);
                        deferredObject.resolve(result);
                    });
            });
        };

        this.saveRegion = (country, region) => {
            return _promiseFactory.deferIndefinitely((deferredObject) => {
                _liveReceptionistOnboardingRepository.saveRegion(this.liveReceptionistOnboardingId(), country, region)
                    .then((result) => {
                        this.state.country(country);
                        this.state.region(region);
                        deferredObject.resolve(result);
                    });
            });
        };

        this.savePostalCode = (country, postalCode) => {
            return _promiseFactory.deferIndefinitely((deferredObject) => {
                _liveReceptionistOnboardingRepository.savePostalCode(this.liveReceptionistOnboardingId(), country, postalCode)
                    .then((result) => {
                        this.state.country(country);
                        this.state.postalCode(postalCode);
                        deferredObject.resolve(result);
                    });
            });
        };

        this.saveTimeZone = (timeZone) => {
            return _promiseFactory.deferIndefinitely((deferredObject) => {
                _liveReceptionistOnboardingRepository.saveTimeZone(this.liveReceptionistOnboardingId(), timeZone)
                    .then((result) => {
                        this.state.timeZone(timeZone);
                        deferredObject.resolve(result);
                    });
            });
        };

        this.saveBusinessHours = (dayOfWeek, openTime, closeTime) => {
            return _promiseFactory.deferIndefinitely((deferredObject) => {
                _liveReceptionistOnboardingRepository.saveBusinessHours(this.liveReceptionistOnboardingId(), dayOfWeek, openTime, closeTime)
                    .then((result) => {
                        switch (dayOfWeek) {
                            case _dayOfWeekEnumeration.monday:
                                this.state.mondayOpenTime(openTime);
                                this.state.mondayCloseTime(closeTime);
                                break;
                            case _dayOfWeekEnumeration.tuesday:
                                this.state.tuesdayOpenTime(openTime);
                                this.state.tuesdayCloseTime(closeTime);
                                break;
                            case _dayOfWeekEnumeration.wednesday:
                                this.state.wednesdayOpenTime(openTime);
                                this.state.wednesdayCloseTime(closeTime);
                                break;
                            case _dayOfWeekEnumeration.thursday:
                                this.state.thursdayOpenTime(openTime);
                                this.state.thursdayCloseTime(closeTime);
                                break;
                            case _dayOfWeekEnumeration.friday:
                                this.state.fridayOpenTime(openTime);
                                this.state.fridayCloseTime(closeTime);
                                break;
                            case _dayOfWeekEnumeration.saturday:
                                this.state.saturdayOpenTime(openTime);
                                this.state.saturdayCloseTime(closeTime);
                                break;
                            case _dayOfWeekEnumeration.sunday:
                                this.state.sundayOpenTime(openTime);
                                this.state.sundayCloseTime(closeTime);
                                break;
                            default:
                                break;
                        }

                        deferredObject.resolve(result);
                    });
            });
        };

        this.resetBusinessHours = () => {
            return _promiseFactory.deferIndefinitely((deferredObject) => {
                _liveReceptionistOnboardingRepository.resetBusinessHours(this.liveReceptionistOnboardingId())
                    .then((result) => {
                        this.state.mondayOpenTime(null);
                        this.state.mondayCloseTime(null);
                        this.state.tuesdayOpenTime(null);
                        this.state.tuesdayCloseTime(null);
                        this.state.wednesdayOpenTime(null);
                        this.state.wednesdayCloseTime(null);
                        this.state.thursdayOpenTime(null);
                        this.state.thursdayCloseTime(null);
                        this.state.fridayOpenTime(null);
                        this.state.fridayCloseTime(null);
                        this.state.saturdayOpenTime(null);
                        this.state.saturdayCloseTime(null);
                        this.state.sundayOpenTime(null);
                        this.state.sundayCloseTime(null);

                        deferredObject.resolve(result);
                    });
            });
        };


        this.saveBusinessDescription = (description) => {
            return _promiseFactory.deferIndefinitely((deferredObject) => {
                _liveReceptionistOnboardingRepository.saveBusinessDescription(this.liveReceptionistOnboardingId(), description)
                    .then((result) => {
                        this.state.businessDescription(description);
                        deferredObject.resolve(result);
                    });
            });
        };

        this.saveOnboardingInformation = (information) => {
            return _promiseFactory.deferIndefinitely((deferredObject) => {
                _liveReceptionistOnboardingRepository.saveOnboardingInformation(this.liveReceptionistOnboardingId(), information)
                    .then((result) => {
                        this.state.addressLineOne(information.addressLineOne);
                        this.state.addressLineTwo(information.addressLineTwo);
                        this.state.city(information.city);
                        this.state.region(information.regionCode);
                        this.state.postalCode(information.postalCode);
                        this.state.country(information.countryCode);
                        this.state.phoneNumber(information.phoneNumber);
                        this.state.faxNumber(information.faxNumber);
                        this.state.emailAddress(information.emailAddress);
                        this.state.websiteUrl(information.websiteUrl);
                        this.state.teamMembers(information.teamMembers || []);
                        deferredObject.resolve(result);
                    });
            });
        };

        this.saveTeamMembers = (teamMembers) => {
            return _promiseFactory.deferIndefinitely((deferredObject) => {
                _liveReceptionistOnboardingRepository.saveTeamMembers(this.liveReceptionistOnboardingId(), teamMembers)
                    .then((result) => {
                        this.state.teamMembers(teamMembers);
                        deferredObject.resolve(result);
                    });
            });
        };

        this.saveMessageRecipients = (messageRecipients) => {
            return _promiseFactory.deferIndefinitely((deferredObject) => {
                _liveReceptionistOnboardingRepository.saveMessageRecipients(this.liveReceptionistOnboardingId(), messageRecipients)
                    .then((result) => {
                        this.state.messageRecipients(messageRecipients);
                        deferredObject.resolve(result);
                    });
            });
        };

        this.saveSmsRecipients = (smsRecipients) => {
            return _promiseFactory.deferIndefinitely((deferredObject) => {
                _liveReceptionistOnboardingRepository.saveSmsRecipients(this.liveReceptionistOnboardingId(), smsRecipients)
                    .then((result) => {
                        this.state.smsRecipients(smsRecipients);
                        deferredObject.resolve(result);
                    });
            });
        };

        this.saveIndustry = (industry) => {
            return _promiseFactory.deferIndefinitely((deferredObject) => {
                _liveReceptionistOnboardingRepository.saveIndustry(this.liveReceptionistOnboardingId(), industry)
                    .then((result) => {
                        this.state.industry(industry);
                        deferredObject.resolve(result);
                    });
            });
        };

        this.saveNumberOfEmployees = (numberOfEmployees) => {
            return _promiseFactory.deferIndefinitely((deferredObject) => {
                _liveReceptionistOnboardingRepository.saveNumberOfEmployees(this.liveReceptionistOnboardingId(), numberOfEmployees)
                    .then((result) => {
                        this.state.numberOfEmployees(numberOfEmployees);
                        deferredObject.resolve(result);
                    });
            });
        };

        this.saveAgentTone = (agentTone) => {
            return _promiseFactory.deferIndefinitely((deferredObject) => {
                _liveReceptionistOnboardingRepository.saveAgentTone(this.liveReceptionistOnboardingId(), agentTone)
                    .then((result) => {
                        this.state.agentTone(agentTone);
                        deferredObject.resolve(result);
                    });
            });
        };

        this.savePhoneNumber = (phoneNumber) => {
            return _promiseFactory.deferIndefinitely((deferredObject) => {
                _liveReceptionistOnboardingRepository.savePhoneNumber(this.liveReceptionistOnboardingId(), phoneNumber)
                    .then((result) => {
                        this.state.phoneNumber(phoneNumber);
                        deferredObject.resolve(result);
                    });
            });
        };

        this.saveFaxNumber = (faxNumber) => {
            return _promiseFactory.deferIndefinitely((deferredObject) => {
                _liveReceptionistOnboardingRepository.saveFaxNumber(this.liveReceptionistOnboardingId(), faxNumber)
                    .then((result) => {
                        this.state.faxNumber(faxNumber);
                        deferredObject.resolve(result);
                    });
            });
        };

        this.saveEmailAddress = (emailAddress) => {
            return _promiseFactory.deferIndefinitely((deferredObject) => {
                _liveReceptionistOnboardingRepository.saveEmailAddress(this.liveReceptionistOnboardingId(), emailAddress)
                    .then((result) => {
                        this.state.emailAddress(emailAddress);
                        deferredObject.resolve(result);
                    });
            });
        };

        this.saveWebsiteUrl = (websiteUrl) => {
            return _promiseFactory.deferIndefinitely((deferredObject) => {
                _liveReceptionistOnboardingRepository.saveWebsiteUrl(this.liveReceptionistOnboardingId(), websiteUrl)
                    .then((result) => {
                        this.state.websiteUrl(websiteUrl);
                        deferredObject.resolve(result);
                    });
            });
        };

        this.saveMayForwardFromNumbers = (mayForwardFromNumbers) => {
            return _promiseFactory.deferIndefinitely((deferredObject) => {
                _liveReceptionistOnboardingRepository.saveMayForwardFromNumbers(this.liveReceptionistOnboardingId(), mayForwardFromNumbers)
                    .then((result) => {
                        this.state.mayForwardFromNumbers(mayForwardFromNumbers);
                        deferredObject.resolve(result);
                    });
            });
        };

        this.saveNumberIntentSelection = (numberIntentSelection) => {
            return _promiseFactory.deferIndefinitely((deferredObject) => {
                _liveReceptionistOnboardingRepository.saveNumberIntentSelection(this.liveReceptionistOnboardingId(), numberIntentSelection)
                    .then((result) => {
                        this.state.numberIntentSelection(numberIntentSelection);
                        deferredObject.resolve(result);
                    });
            });
        };

        this.saveCallerFollowUp = (callerFollowUp) => {
            return _promiseFactory.deferIndefinitely((deferredObject) => {
                _liveReceptionistOnboardingRepository.saveCallerFollowUp(this.liveReceptionistOnboardingId(), callerFollowUp)
                    .then((result) => {
                        this.state.callerFollowUp(callerFollowUp);
                        deferredObject.resolve(result);
                    });
            });
        };

        this.saveCallerFollowUpOther = (callerFollowUpOther) => {
            return _promiseFactory.deferIndefinitely((deferredObject) => {
                _liveReceptionistOnboardingRepository.saveCallerFollowUpOther(this.liveReceptionistOnboardingId(), callerFollowUpOther)
                    .then((result) => {
                        this.state.callerFollowUpOther(callerFollowUpOther);
                        deferredObject.resolve(result);
                    });
            });
        };

        this.saveOnboardingStatus = (onboardingStatus) => {
            return _promiseFactory.deferIndefinitely((deferredObject) => {
                _liveReceptionistOnboardingRepository.saveOnboardingStatus(this.liveReceptionistOnboardingId(), onboardingStatus)
                    .then((result) => {
                        this.state.onboardingStatus(onboardingStatus);
                        deferredObject.resolve(result);
                    });
            });
        };

        this.getProgressPercentage = () => {
            return _promiseFactory.defer((promise) => {
                promise.resolve(this.progressPercentage());
            });
        };

        this.setProgressPercentage = (newPercentage) => {
            return _promiseFactory.defer((promise) => {
                if (newPercentage < 0 || newPercentage > 100) {
                    promise.reject("Percentage must be between 0 and 100.");
                    return;
                }

                this.progressPercentage(newPercentage);
                promise.resolve(this.progressPercentage());
            });
        };

        const _onOnboardingCompleted = () => {
            this.state.onboardingStatus(_liveReceptionistOnboardingStatus.accountOnboardingCompleted);
        };

        _liveReceptionistOnboardingRepository.onLiveReceptionistOnboardingCompleted(_onOnboardingCompleted);
        _disposables.push(_liveReceptionistOnboardingRepository);
    };


    LiveReceptionistOnboardingSingleton.singleton = new LiveReceptionistOnboardingSingleton();

    return LiveReceptionistOnboardingSingleton.singleton;
});
